import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

type SelectFilterProps<T extends string|number> = {
    value: Date | null,
    options: { value: T, label: string }[]
    setValue: (value: Date | null) => void
    className?: string
}

export const DateFilter = <T extends string|number>(props: SelectFilterProps<T>) => {
    return (
        <DatePicker
            selected={props.value}
            onChange={props.setValue}
            dateFormat="dd/MM/yyyy"
            className="form-control"
        />
    )
}